<template>
    <div class="tenderDetails">
        <div class="topNav">
            <el-button size="mini" @click="$router.push({'name': 'myBidding'})">返回</el-button>
            <span class="margin-left" v-has="'06010010'" v-if="bidingInfo.bidStatus === '30' && bidingInfo.supplierBidStatus === '3' && !bidingInfo.depositEndTimeFlag">
                <el-button size="mini" class="el-button el-button--primary" @click="bondFn(bidingInfo)">缴纳投标保证金</el-button>
            </span>
            <span class="margin-left" v-has="'06010011'" v-if="bidingInfo.bidStatus >= 30 && bidingInfo.bidStatus <= 80 &&
                (bidingInfo.supplierBidStatus === '5' || bidingInfo.supplierBidStatus === '6' || bidingInfo.supplierBidStatus === '11')">
                <el-button size="mini" class="el-button el-button--primary" @click="sealFn">应标文件盖章</el-button>
            </span>
            <span v-has="'06010012'" class="margin-left" v-if="bidingInfo.bidStatus >= 30 && bidingInfo.bidStatus <= 80 &&
                (bidingInfo.supplierBidStatus === '9' || bidingInfo.supplierBidStatus === '12' || bidingInfo.supplierBidStatus === '13')">
                <el-button size="mini" class="el-button el-button--primary" @click="sealFn">应标文件预览</el-button>
            </span>
            <!-- <span v-has="'06010013'" class="margin-left" v-if="bidingInfo.bidStatus === '53' &&
                (bidingInfo.supplierBidStatus === '12' || bidingInfo.supplierBidStatus === '13')">
                <el-button size="mini" class="el-button el-button--primary" @click="sealbidPrice">中标价格表盖章</el-button>
            </span>
            <span v-has="'06010014'" class="margin-left" v-if="bidingInfo.bidStatus > 53 && bidingInfo.supplierBidStatus === '9'" @click="sealbidPrice">
                <el-button size="mini" class="el-button el-button--primary">中标价格表预览</el-button>
            </span> -->
        </div>
        <div class=detial-cont-box>
            <div class="content">
                <div class="content-box">
                    <div><span class="content-title">{{bidingInfo.bidName}}</span> <span class="content-label">{{bidingInfo.supplierBidStatusText}}</span></div>
                    <div class="content-desc">
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{bidingInfo.bidNo}}</span></span>
                        <span class="content-desc-item">标书购买时间<span class="content-desc-cont">{{bidingInfo.purchaseStartTime}}</span></span>
                        <span class="content-desc-item">报价开始时间<span class="content-desc-cont">{{bidingInfo.quoteStartTime}}</span></span>
                        <span class="content-desc-item">保证金提交截止时间<span class="content-desc-cont">{{bidingInfo.depositEndTime}}</span></span>
                        <span class="content-desc-item">币种<span class="content-desc-cont">{{bidingInfo.currency}}</span></span>
                    </div>
                </div>
                <div class="content-right">
                    <div class="content-right-deposit">
                        <div><span class="money">{{bidingInfo.deposit}} </span>元</div>
                        <div class="money-text-mt">投标保证金金额</div>
                    </div>
                    <div class="content-right-bidprice">
                        <div><span class="money">{{bidingInfo.bidPrice}} </span>元</div>
                        <div class="money-text-mt">标书费</div>
                    </div>
                </div>
            </div>
            <div class="tab1">
                <div class="tab1-title">招标文件清单</div>
                <el-table :data="moduleFiles" class="table-width" border tooltip-effect='dark'>
                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                    <el-table-column prop="moduleTypeText" label="文件类型" width="220" align="center"></el-table-column>
                    <el-table-column prop="fileName" label="文件名称"></el-table-column>
                    <el-table-column prop="updateTime" width="220" label="上传日志" align="center"></el-table-column>
                    <el-table-column prop="action" width="220" label="操作" align="center">
                        <template slot-scope="scope">
                            <span v-has="'06010007'"><el-button type="text" size="small" @click="previewFunc(scope.row)">预览</el-button></span>
                            <span class="margin-left" v-has="'06010008'"><el-button type="text" size="small" @click="downLoad(scope.row)">下载</el-button></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="tab2">
                <div class="tab1-title">轮次报价</div>
                <el-table :data="bidingInfo.quotationOrder" class="table-width" border tooltip-effect='dark'>
                    <el-table-column prop="roundCurrent" label="轮次编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="tenderStatus" label="状态" width="200" align="center"></el-table-column>
                    <el-table-column prop="quoteType" width="200" label="竞价类型" align="center">
                        <template slot-scope="scope">
                            <div>{{scope.row.quoteTypeText}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="竞价信息" align="center">
                        <template slot-scope="scope">
                            <div>开始时间：{{scope.row.effectDateFrom}} - 结束时间：{{scope.row.effectDateTo}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" label="距离结束时间" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.tenderStatusCode === '3' || scope.row.tenderStatusCode === '2'">-</div>
                            <div v-if="scope.row.tenderStatusCode === '1'">{{timeover}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" width="190" label="操作" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.roundCurrent === bidingInfo.quotationOrder.length &&
                                (scope.row.tenderStatusCode === '3' &&
                                (bidingInfo.bidStatus === '50' && bidingInfo.supplierBidStatus === '7' && !bidingInfo.effectDateFromFlag ||
                                bidingInfo.bidStatus === '30' && bidingInfo.supplierBidStatus === '7')) ||
                                scope.row.tenderStatusCode === '3'">
                                等待竞价
                            </div>
                            <span v-else v-has="'06010009'">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">
                                    {{scope.row.tenderStatusCode === '2' ? '查询报价' : '进入报价'}}
                                </el-button>
                            </span>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <payDialog :showPd="payshow" :myBidFlag="myBidFlag" :payDialogRowData="payDialogRowData" @payDialogEvent="payDialogEvent" :payTitle="'缴纳保证金'"></payDialog>
        <MDialog :MDialogshow="MDialogshow" :rowBidDialogData="rowBidDialogData" @mdialogFn="mdialogFn"></MDialog>
        <!-- <Bid-Price-List :payTitle="'中标价格表盖章'" :originFlag="'1'" :MDialogshow="bidPayshow" :rowBidDialogData="bidPayshowRowData" @mdialogFn="mdialogFn"></Bid-Price-List> -->
    </div>
</template>
<script>
import { MessageBox } from 'element-ui';
import { logout } from '@/utils/index';
import MDialog from '../bidManagement/BidDialog.vue';
// import BidPriceList from '../bidManagement/BidPriceList.vue';
import payDialog from '../bidManagement/payDialog.vue';
import { supplierDetails } from '../../../../lsrm/api/myBidding.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { filePreview } from '@/utils/filePreview.js';
export default {
    components: { MDialog, payDialog },
    data() {
        return {
            myBidFlag: false,
            MDialogshow: false,
            bidPayshow: false,
            rowBidDialogData: {},
            bidPayshowRowData: {},
            bidingInfo: {},
            timer: null,
            maxtime: '',
            timeover: '',
            dictData: [],
            moduleFiles: [],
            payDialogRowData: {},
            payshow: false
        };
    },
    mounted() {
        dictWithUrl('BID_HEAD_FILE_TYPE,SU_SUPPLIER_BID_STATUS,BID_SU_TENDER_TYPE').then(res => {
            this.dictData = res.data;
            supplierDetails(this.$route.query.id).then(res => {
                if (res && +res.code === 0) {
                    if (this.$store.state.supplier.supplierCode !== res.data.supplierCode) {
                        MessageBox.alert('当前登陆账号有误，请重新登陆', '错误', {
                            confirmButtonText: '确定',
                            callback: action => {
                                logout();
                            }
                        });
                    }
                    this.bidingInfo = this.conversionParam(res.data);
                    this.moduleFiles = this.conversionData(res.data.moduleFiles);
                    const serveTime = new Date(res.timestamp.replace(' ', 'T')).getTime();
                    const depositEndTime = new Date(this.bidingInfo.depositEndTime).getTime();
                    this.bidingInfo.depositEndTimeFlag = serveTime > depositEndTime; // 保证金截止时间
                    const data = [...this.bidingInfo.quotationOrder];
                    data.forEach(el => {
                        el.quoteTypeText = this.dictData.BID_SU_TENDER_TYPE[el.quoteType];
                        const startTime = new Date(el.effectDateFrom.replace(' ', 'T')).getTime();
                        const endTime = new Date(el.effectDateTo.replace(' ', 'T')).getTime();
                        if (el.tenderStatus === '3' || el.tenderStatus === '4' || serveTime > endTime) {
                            el.tenderStatus = '已结束';
                            el.tenderStatusCode = '2';
                        } else if (serveTime > startTime && serveTime < endTime) {
                            el.tenderStatus = '正在进行';
                            el.tenderStatusCode = '1';
                            this.maxtime = (endTime - serveTime) / 1000;
                            this.timer = setInterval(() => {
                                this.countDown();
                            }, 1000);
                        } else if (serveTime < startTime) {
                            el.tenderStatus = '等待竞价';
                            el.tenderStatusCode = '3';
                        }
                    });
                }
            });
        });
    },
    methods: {
        payDialogEvent(data) {
            this.payshow = false;
            this.myBidFlag = false;
        },
        bondFn(row) {
            this.payshow = true;
            this.myBidFlag = true;
            this.payDialogRowData = row;
        },
        previewFunc(row) {
            filePreview(row);
        },
        conversionData(moduleFiles) {
            moduleFiles.forEach(el => {
                el.moduleTypeText = this.dictData.BID_HEAD_FILE_TYPE[el.moduleType];
            });
            return moduleFiles;
        },
        conversionParam(obj) {
            const data = { ...obj };
            data.supplierBidStatusText = this.dictData.SU_SUPPLIER_BID_STATUS[data.supplierBidStatus];
            return data;
        },
        sealbidPrice(row) {
            this.bidPayshow = true;
            this.bidPayshowRowData = this.bidingInfo;
        },
        mdialogFn() {
            this.MDialogshow = false;
            this.bidPayshow = false;
        },
        sealFn() {
            this.MDialogshow = true;
            this.rowBidDialogData = this.bidingInfo;
        },
        handleClick(row) {
            this.$router.push({
                name: 'myTender',
                query: {
                    bidNo: this.bidingInfo.bidNo,
                    tenderCode: row.tenderCode
                }
            });
        },
        downLoad(row) {
            window.open(row.fileUrl, '_parent');
        },
        countDown() {
            if (this.maxtime >= 0) {
                const hour = Math.floor(this.maxtime / 60 / 60) < 10 ? '0' + Math.floor(this.maxtime / 60 / 60) : Math.floor(this.maxtime / 60 / 60);
                const minutes = Math.floor(this.maxtime / 60 % 60) < 10 ? '0' + Math.floor(this.maxtime / 60 % 60) : Math.floor(this.maxtime / 60 % 60);
                const seconds = Math.floor(this.maxtime % 60) < 10 ? '0' + Math.floor(this.maxtime % 60) : Math.floor(this.maxtime % 60);
                --this.maxtime;
                this.timeover = hour + ':' + minutes + ':' + seconds;
            } else {
                clearInterval(this.timer);
            }
        }
    }
};
</script>

<style lang="less">
.tenderDetails {
    margin: 0 10px;
    font-size: 12px;
    background: #fff;
    .margin-left {
        margin-left: 10px;
    }
    .detial-cont-box {
        min-height: calc(~"100vh - 110px") !important;
        max-height: calc(~"100vh - 110px") !important;
        overflow-y: auto;
    }
    .topNav {
        margin-top: 10px;
        padding-left: 10px;
        width: 100%;
        height: 46px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
    .content {
        margin: 10px;
        padding: 14px;
        box-sizing: border-box;
        background: #F8F8F8;
        vertical-align: middle;
        display: flex;
        align-items: center;
        .content-box {
            width: 100%;
        }
        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }
        .content-label {
            margin-left: 12px;
            padding: 3px 6px;
            border-radius: 2px;
            background: #FF7C24;
            display: inline-block;
            color: #fff;
        }
        .content-desc {
            margin-top: 15px;
            width: 85%;
            display: flex;
            flex-wrap: wrap;
        }
        .content-desc-item {
            margin-bottom: 4px;
            width: 33.3%;
            color: #888888;
        }
        .content-desc-cont {
            margin-left: 5px;
            color: #333333;
        }
        .content-right {
            display: flex;
        }
        .content-right-deposit {
            margin-right:30px;
            width: 108px;
        }
        .content-right-bidprice {
            width: 108px;
        }
        .money-text-mt {
            margin-top:4px;
        }
        .money {
            font-size: 18px;
            font-weight: 700;
            color: #FF8800;
        }
    }
    .tab1 {
        padding: 10px;
        .tab1-title {
            margin-bottom: 10px;
        }
        .table-width {
            width: 100%
        }
    }
    .tab2 {
        padding: 10px;
        .tab1-title {
            margin-bottom: 10px;
        }
        .table-width {
            width: 100%
        }
    }
}

</style>